export default [
    {
        path: '/interventions',
        component: () => import('@/pages/interventions/Interventions.vue'),
        name: 'interventions-home',
    },
];
